import AOS from 'aos';
/**
 * Functionality for Animate on Slide
 * https://michalsnik.github.io/aos/
 */
const Aos =()=> {
	AOS.init({
		once: true
	});

};
export default Aos;



